import React, { memo } from "react";
import { useTranslate } from "helpers";
import { UserContactStepProps } from "./types";
import { EmailTextField } from "ui/components/TextField/EmailTextField";
import { PhoneTextField } from "ui/components/TextField/PhoneTextField";
import { MobilePhoneTextField } from "ui/components/TextField/MobilePhoneTextField";
import { useHandleTextFieldChange } from "services/forms/hooks";

const UserContactStep: React.FC<UserContactStepProps> = ({
  formValues,
  setFormValues,
  errors,
}) => {
  const { t } = useTranslate();

  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);

  return (
    <div className="flex items-center justify-center px-4 mt-8 xl:mt-16 min-h-[60vh] xl:min-h-[600px]">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
          Kontakt
        </h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          Unesite kontakt podatke korisnika. Potreban je barem jedan broj
          (mobitel ili telefon) i email.
        </p>
        <div className="border border-slate-200">
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">
                  Kontakt podaci
                </h3>
                <p className="text-xs text-slate-500">
                  Mobitel, telefon i email korisnika
                </p>
            </div>
            <div className="flex gap-4 mb-3">
              <div className="flex-1">
                <MobilePhoneTextField
                  type="text"
                  name="mobilePhoneNumber"
                  label={t("admin.user.edit.mobilephonenumber")}
                  placeholder={t("admin.user.edit.mobilephonenumber.placeholder")}
                  onChange={handleTextFieldChange}
                  value={formValues.mobilePhoneNumber}
                  error={errors.mobilePhoneNumber}
                />
              </div>
              <div className="flex-1">
                <PhoneTextField
                  type="text"
                  name="phoneNumber"
                  label={t("admin.user.edit.phonenumber")}
                  placeholder={t("admin.user.edit.phonenumber.placeholder")}
                  onChange={handleTextFieldChange}
                  value={formValues.phoneNumber}
                  error={errors.phoneNumber}
                />
              </div>
            </div>
            <div>
              <EmailTextField
                type="text"
                name="email"
                label={t("admin.user.edit.email")}
                placeholder={t("admin.user.edit.email.placeholder")}
                onChange={handleTextFieldChange}
                value={formValues.email}
                error={errors.email}
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(UserContactStep);
